(function () {
    'use strict';
  
    const ERROR_MESSAGE = 'Bu alan zorunludur.';
    const CONSENT_CHECKBOX_IDS = ['kvkkConsentCheckbox', 'salesConsentCheckbox'];
    const CHECKOUT_SELECTOR = 'button[name="checkout"]';
    const CART_FORM_SELECTOR = 'form.cart-page';
  
    function getCheckbox(id) {
      return document.getElementById(id);
    }
  
    function getConsentCheckboxes() {
      return CONSENT_CHECKBOX_IDS
        .map(id => getCheckbox(id))
        .filter(Boolean);
    }
  
    function areAllConsentsChecked() {
      const boxes = getConsentCheckboxes();
      if (boxes.length === 0) return true;
  
      return boxes.every(box => {
        if (!box.required) return true;
        return box.checked;
      });
    }
  
    function setCustomValidityFor(box) {
      if (!box || !box.required) return;
  
      if (box.checked) {
        box.setCustomValidity('');
      } else {
        box.setCustomValidity(ERROR_MESSAGE);
      }
    }
  
    function showFirstConsentError() {
      const boxes = getConsentCheckboxes();
      const firstInvalid = boxes.find(box => box.required && !box.checked);
  
      if (!firstInvalid) return;
  
      firstInvalid.setCustomValidity(ERROR_MESSAGE);
      requestAnimationFrame(() => {
        firstInvalid.reportValidity();
      });
    }
  
    document.addEventListener('change', function (event) {
      const target = event.target;
      if (!target) return;
      if (!CONSENT_CHECKBOX_IDS.includes(target.id)) return;
  
      setCustomValidityFor(target);
    });
  
    document.addEventListener('click', function (event) {
      const target = event.target;
      if (!target) return;
      if (!CONSENT_CHECKBOX_IDS.includes(target.id)) return;
  
      setTimeout(() => {
        setCustomValidityFor(target);
      }, 0);
    });
  
    document.addEventListener('click', function (event) {
      const btn = event.target && event.target.closest(CHECKOUT_SELECTOR);
      if (!btn) return;
  
      if (!areAllConsentsChecked()) {
        event.preventDefault();
        event.stopPropagation();
        showFirstConsentError();
      }
    });
  
    document.addEventListener('submit', function (event) {
      const form = event.target;
      if (!form) return;
  
      if (!form.matches(CART_FORM_SELECTOR)) return;
  
      if (!areAllConsentsChecked()) {
        event.preventDefault();
        event.stopPropagation();
        showFirstConsentError();
      }
    });
  
    function initValidity() {
      getConsentCheckboxes().forEach(setCustomValidityFor);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initValidity);
    } else {
      initValidity();
    }
  })();
  